export default "__VITE_ASSET__NDlZ7syE__"